export default "__VITE_ASSET__BnR6q9LD__"